<style lang="less">
    @import '../../styles/public/public.less';
    .operations{
        width: 100%;
        height: 100%;
        .operations1{
            width: 100%;
            height: 100%;
            .operations_bq{
                height: 50px;
                width: 100%;
                .operations_bqleft{
                    height: 100%;
                    width: 50px;
                    .operations_bq_1{
                        height: 100%;
                        .operations_wz{
                            width: 150px;
                            height: 100%;
                            .operations_xz{
                                color: #ffffff !important;
                                background-image: url("../../../static/images/xz.png") !important;
                                background-repeat: no-repeat;
                                background-size: 100% 100%;
                            }
                            .operations_wzz{
                                cursor: pointer;
                                height: 38px;
                                width: 150px;
                                padding: 0px 10px;
                                color: #000;
                                background-size: 100% 100%;
                                background-repeat: no-repeat;
                                // background-image: url("../../../static/images/sbx1.png");
                            }
                            .operations_wzz:hover{
                                color: #ffffff !important;
                                background-image: url("../../../static/images/xz.png");
                                background-repeat: no-repeat;
                                background-size: 100% 100%;
                            }
                        }
                    }
                    .operations_bq_2{
                        height: 100%;
                        margin-top: 30px;
                        z-index: 1;
                    }
                }
                .operations_bqright{
                    height: 100%;
                }
                
            }
            .operations_nr{
                width: 100%;
                height: 100px;
            }
        }
    }
</style>
<template>
    <div class="operations">
        <div class="operations1 display_column_jc">
            <div class="operations_bq display_row_js media_w_w14 dispaly_flex00">
                <div class="operations_bqleft display_row_js dispaly_flex11">
                    <div class= "operations_bq_1 display_row_js">
                        <div v-for="item in list" v-show="item.show" class="operations_wz display_row_ac"  @click="click_Menu(item)">
                            <div class="operations_wzz display_row_jc_ac" :class="{'operations_xz':item.judge}">
                                <span class="media_w_w18">{{item.name}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="operations_bq_2 display_row_ac">
                        <Input search placeholder="搜索内容" v-model="keywords" style="width: 200px;margin-right:20px" @on-search="search" />
                        <Button type="error" style="margin-right:10px" @click="click_delect()">删除</Button>
                        <Button type="success" @click="click_new()">新增</Button>
                    </div>
                </div>
                <div class="operations_bqright dispaly_flex00 media_w_unitnr2">

                </div>
            </div>
            <div class="operations_nr dispaly_flex11">
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<script>
    import bus from "../../app/event";
    export default {
        components: {
        },
        data() {
            return {
                keywords:'',
                title:"",
                list:[
                    {
                        judge:false,
                        show:true,
                        name:"单位管理",
                        path:"/unit",
                    },
                    {
                        judge:false,
                        show:true,
                        name:"用户管理",
                        path:"/user"
                    },
                    /* {
                        judge:false,
                        name:"角色管理",
                        path:"/role"
                    } */
                ]
            };
        },
        methods: {
            search:function(){
                bus.$emit('contentsearch',this.keywords)                
                },
            click_delect:function(){
                bus.$emit("operations_new","删除");
            },
            click_new:function(){
                
                bus.$emit("operations_new","新增");
            },
            click_Menu:function(item){
                if (item) {
                    this.$router.push(item.path);
                }
                for (var i = 0; i < this.list.length; i++) {
                    if (this.list[i].path == this.$root._route.path) {
                        this.list[i].judge = true;  
                        this.title = this.list[i].name;
                    }else{
                        this.list[i].judge = false; 
                    }                      
                }
            },
        },
        mounted() {
            sessionStorage.getItem('AOTHOR_ID') == '1'?this.list[0].show=false:null;
            this.click_Menu();
            bus.$on('clearkeywords',()=>{
                    this.keywords='';
                })
        },
        beforeDestroy(){
            bus.$off('operations_new');
            bus.$off('clearkeywords');
        },
        destoryed(){
        },
    };
</script>




// WEBPACK FOOTER //
// operations.vue?f1a9f48a